import { Button, EmptyState as ChakraEmptyState } from '@chakra-ui/react'
import type { ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
  icon?: ReactNode
}

export function EmptyState({ title, description, actionLabel, onAction, icon }: EmptyStateProps) {
  return (
    <ChakraEmptyState.Root>
      <ChakraEmptyState.Content>
        {icon && <ChakraEmptyState.Indicator>{icon}</ChakraEmptyState.Indicator>}
        <ChakraEmptyState.Title>{title}</ChakraEmptyState.Title>
        {description && <ChakraEmptyState.Description>{description}</ChakraEmptyState.Description>}

        {actionLabel && onAction && (
          <Button colorPalette="blue" onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </ChakraEmptyState.Content>
    </ChakraEmptyState.Root>
  )
}
